export default __webpack_public_path__ + "static/media/5. EV Public Charging Lane Factsheet.51439fd5.pdf";